module.exports = __webpack_public_path__ + "static/media/DSC_6835.d3dceae5.jpg";